import { render, staticRenderFns } from "./TreeDisk.vue?vue&type=template&id=229bf128&scoped=true"
import script from "./TreeDisk.vue?vue&type=script&lang=js"
export * from "./TreeDisk.vue?vue&type=script&lang=js"
import style0 from "./TreeDisk.vue?vue&type=style&index=0&id=229bf128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229bf128",
  null
  
)

export default component.exports